<template>
  <div>
    <HeroProductos />
    <CarouselPropio v-if="false" />
    <Productos id="seccion-productos" />
    <Promo />
    <Redes />
    <WhatsappFlotante />
  </div>
</template>

<script>
import CarouselPropio from '@/components/Carousel.vue'
import Promo from '@/components/Promo.vue'
import Redes from '@/components/Redes.vue'
import HeroProductos from '@/components/Hero.vue'
import WhatsappFlotante from '@/components/WhatsappFlotante.vue'
import Productos from '@/components/Productos/Productos.vue'

export default {
  name: 'Inicio',
  components: {
    CarouselPropio,
    Promo,
    Redes,
    HeroProductos,
    Productos,
    WhatsappFlotante
  }
}
</script>
